module.exports = __webpack_public_path__ + "img/g10.526d3113.jpg";